<template>
    <table class="table is-responsive-table is-fullwidth is-scrollable is-striped">
        <thead>
        <tr>
            <th><span @click="setOrder('id')" class="link">INV#</span></th>
            <th><span @click="setOrder('issued_date')" class="link">Date</span></th>
            <th><span @click="setOrder('user_id')" class="link">Client</span></th>
            <th><span @click="setOrder('incharge')" class="link">In Charge</span></th>
            <th><span @click="setOrder('sale')" class="link">Sales</span></th>
            <th><span @click="setOrder('cost')" class="link">Cost</span></th>
            <th><span @click="setOrder('profit')" class="link">Profit</span></th>
            <th><span @click="setOrder('locked')" class="link">Status</span></th>
            <th v-if="isAdmin"><span @click="setOrder('zoho_id')" class="link">Zoho</span></th>
            <th v-if="isAdmin">Action (ZOHO)</th>
        </tr>
        </thead>
        <tbody>
            <profit-invoice-table-row v-for="invoice in invoices" :invoice="invoice"></profit-invoice-table-row>
        </tbody>
    </table>
</template>

<script>
    import ProfitInvoiceTableRow from './ProfitInvoiceTableRow'
    export default {
        components: {
            ProfitInvoiceTableRow
        },
        methods: {
            setOrder(column) {
                this.$store.getters.getProfitSectionInvoiceQuery.order_type === 'ASC' ? this.$store.dispatch('setProfitSectionInvoiceQueryFieldValue', {field: 'order_type', value:'DESC'}) : this.$store.dispatch('setProfitSectionInvoiceQueryFieldValue', {field: 'order_type', value:'ASC'})
                this.$store.dispatch('setProfitSectionInvoiceQueryFieldValue', {field: 'order_column', value:column})
                this.$store.dispatch('fetchProfitSectionInvoicesWithQuery')
            }
        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            invoices() {
                return this.$store.getters.getProfitSectionData.invoices
            }
        }
    }
</script>

<style scoped>
    .is-responsive-table th {
        font-size: small;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitInvoicesTable.vue